import React from "react";
import {
  Row,
  Col,
  CardBody,
  Card,
  CardHeader,
  Label,
  CardImg,
} from "reactstrap";
import Page from "components/Page";
import { Link } from "react-router-dom";
import { ReactTitle } from "react-meta-tags";
import AppConstants from "AppConstants";
import Switch from "react-switch";
import axios from "axios";
import placeholderimg from "../../assets/img/placeholder.png";
import {
  MdInfoOutline,
  MdQuestionAnswer,
  MdLibraryBooks,
} from "react-icons/md";
import swal from "sweetalert";
import ViewMentorTodo from "./viewMentorTodos";
import Thermometerdt from "../Children/thermometerDT";
import { connect } from "react-redux";

class ViewMentor extends React.Component {
  constructor() {
    super();
    this.state = {
      firstname: "",
      middlename: "",
      lastname: "",
      full_name: "",
      gender: "",
      street: "",
      address1: "",
      address2: "",
      city: "",
      state: "",
      employer_name: "",
      zipcode: "",
      homephone: "",
      mobilephone: "",
      nameaddressofemployer: "",
      workphone: "",
      occupation: "",
      emailaddress: "",
      grade_preference: "",
      strengths: "",
      reason_behind_mentor: "",
      statement_behind_mentor: "",
      intial_statement: "",
      intial_statement_ques1: "",
      intial_statement_ques2: "",
      convicted_misdemeanor: "",
      current_indictment: "",
      explaination1: "",
      explaination2: "",
      educational_background: "",
      available_days: [],
      best_time_for_voluntee: [],
      referal_addresses: [],
      signature: "",
      are_you_student: "",
      currently_enrolled: "",
      currently_employed: "",
      //Optional Information:
      social_security_number: "",
      date_of_birth: "",
      prefer_particular_grade_level: "",
      prefer_particular_gender: "",
      prefer_quiet: "",
      prefer_outgoing_child: "",
      prefer_specific_racial: "",
      prefer_specific_racial_text: "",
      foreign_language: "",
      foreign_language_other: "",
      hobbies: "",
      like_to_be_mentee: "",
      clubs_or_groups: "",
      favorite_subject: "",
      least_favorite_subject: "",
      enjoyed_activities: [],
      qualities_like_in_mentee: "",
      role_model: "",
      recommend_book: "",
      grade_preference: "",
      status: true,
      profile_img: "",
      approval: false,
      program: "",
      signature: "",
      isNewUser:false,
      admin_res: false,
    };
    this.handleStatus = this.handleStatus.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleResponse = this.handleResponse.bind(this);
  }
  handleResponse(checked) {
    swal({
      title: "Are you sure",
      text: "you want to respond for this participant?",
      icon: "warning",
      buttons: ["Go back", "Confirm"],
      dangerMode: false,
    }).then((willDelete) => {
      if (willDelete) {
        swal("Respond Succesfully!", {
          icon: "success",
        });
        const data = {
          mentor_id: this.props.match.params.id,
          id: this.props.auth.user._id,
          adminResponse: checked,
        };
        axios
          .post(
            AppConstants.API + "/thermometerReading/mailsAfterAdminResponse",
            data
          )
          .then((res) => {
            if (res.data.Status == "Success") {
              this.setState({ admin_res: checked });
            }
          });
      }
    });
  }
  handleChange(checked) {
    swal({
      title: "Are you sure",
      text: "you want to approve this participant?",
      icon: "warning",
      buttons: ["Go back", "Confirm"],
      dangerMode: false,
    }).then((willDelete) => {
      if (willDelete) {
        swal("Participant has been approved!", {
          icon: "success",
        });
        const data = {
          id: this.props.match.params.id,
          approve: checked,
        };
        axios
          .post(AppConstants.API + "/mentor/adminApprovalMentor/", data)
          .then((res) => {
            if (res.data.Status == "Success") {
              this.setState({ approval: checked });
            }
          });
      }
    });
  }
  // handleChange(checked) {
  //     const data = {
  //       id : this.props.match.params.id,
  //       approve : checked
  //     }
  //     axios.post(AppConstants.API+'/mentor/adminApprovalMentor/',data).then(res => {
  //       if(res.data.Status=="Success"){
  //         this.setState({ approval:checked });
  //       }
  //     })
  //   }
  handleStatus(checked) {
    swal({
      title: "Are you sure",
      text: "you want to change the status?",
      icon: "warning",
      buttons: ["Go back", "Confirm"],
      dangerMode: false,
    }).then((willDelete) => {
      if (willDelete) {
        swal("Status has been changed!", {
          icon: "success",
        });
        const data = {
          status: checked,
        };
        axios
          .post(
            AppConstants.API +
              "/mentor/updateMentorStatus/" +
              this.props.match.params.id,
            data
          )
          .then((res) => {
            if (res.data.Status == "Success") {
              this.setState({ status: checked });
            }
          });
      }
    });
  }
  componentDidMount() {
    var that = this;
    fetch(
      AppConstants.API +
        "/mentor/getMentorSingleReading/" +
        this.props.match.params.id
    )
      .then(function (res) {
        if (res.status == 200) {
          return res.json();
        }
      })
      .then(function (data) {
        if (data && data.Status == "Success" && data.data.thermometerData != undefined) {
          that.setState({
            admin_res: data.data.thermometerData.adminResponse,
          });
        }
      });
    fetch(
      AppConstants.API + "/mentor/getMentorData/" + this.props.match.params.id
    )
      .then(function (res) {
        if (res.status == 200) {
          return res.json();
        }
      })
      .then(function (data) {
        console.log(
          "data.data[0].clubs_or_groups",
          data.data[0].clubs_or_groups
        );
        that.setState({
          firstname: data.data[0].first_name,
          middlename: data.data[0].middle_name,
          lastname: data.data[0].last_name,
          full_name: data.data[0].full_name,
          gender: data.data[0].gender,
          street: data.data[0].street,
          address1: data.data[0].address1,
          address2: data.data[0].address2,
          city: data.data[0].city,
          state: data.data[0].state,
          zipcode: data.data[0].zipcode,
          employer_name: data.data[0].employer_name,
          homephone: data.data[0].home_phone,
          mobilephone: data.data[0].mobile_phone,
          nameaddressofemployer: data.data[0].employer_address,
          workphone: data.data[0].work_phone,
          occupation: data.data[0].occupation,
          emailaddress: data.data[0].email,
          status: data.data[0].status,
          approval: data.data[0].approval,
          profile_img: data.data[0].profile_image,
          grade_preference: data.data[0].grade_preference,
          strengths: data.data[0].strengths,
          reason_behind_mentor: data.data[0].reason_behind_mentor,
          statement_behind_mentor: data.data[0].statement_behind_mentor,
          intial_statement_ques1: data.data[0].intial_statement_ques1,
          intial_statement_ques2: data.data[0].intial_statement_ques2,
          explaination1: data.data[0].explaination1,
          explaination2: data.data[0].explaination2,
          intial_statement: data.data[0].intial_statement,
          convicted_misdemeanor: data.data[0].convicted_misdemeanor,
          current_indictment: data.data[0].current_indictment,
          explaination: data.data[0].explaination,
          educational_background: data.data[0].educational_background,
          available_days: data.data[0].available_days,
          best_time_for_voluntee: data.data[0].best_time_for_voluntee,
          are_you_student: data.data[0].are_you_student,
          currently_enrolled: data.data[0].currently_enrolled,
          currently_employed: data.data[0].currently_employed,
          referal_addresses: data.data[0].referal_addresses,
          signature: data.data[0].signature,

          //Optional Information:
          social_security_number: data.data[0].social_security_number,
          date_of_birth: data.data[0].date_of_birth,
          prefer_particular_grade_level:
            data.data[0].prefer_particular_grade_level,
          prefer_particular_gender: data.data[0].prefer_particular_gender,
          prefer_quiet: data.data[0].prefer_quiet,
          prefer_outgoing_child: data.data[0].prefer_outgoing_child,
          prefer_specific_racial: data.data[0].prefer_specific_racial,
          prefer_specific_racial_text: data.data[0].prefer_specific_racial_text,
          foreign_language: data.data[0].foreign_language,
          foreign_language_other: data.data[0].foreign_language_other,
          hobbies: data.data[0].hobbies,
          like_to_be_mentee: data.data[0].like_to_be_mentee,
          clubs_or_groups: data.data[0].clubs_or_groups,
          favorite_subject: data.data[0].favorite_subject,
          least_favorite_subject: data.data[0].least_favorite_subject,
          enjoyed_activities: data.data[0].enjoyed_activities,
          qualities_like_in_mentee: data.data[0].qualities_like_in_mentee,
          role_model: data.data[0].role_model,
          recommend_book: data.data[0].recommend_book,
          grade_preference: data.data[0].grade_preference,
          program: data.data[0].program,
          isNewUser:data.data[0].isNewUser
          // view_logo: data.data[0].profile_image,
          // old_img: data.data[0].profile_image,
        });
      });
    var element = document.getElementById("navItem-Mentors-2");
    element.classList.add("active");
  }
  render() {
    let image;
    if (
      this.state.profile_img == "" ||
      this.state.profile_img == undefined ||
      this.state.profile_img == "undefined" ||
      this.state.profile_img == null
    ) {
      image = placeholderimg;
    } else {
      image = this.state.profile_img;
    }

    let sig;

    sig = this.state.signature;

    let parent_status;
    if (this.state.status == true) {
      parent_status = <p className="mr-2 badge badge-success  p-2">active</p>;
    } else {
      parent_status = (
        <p className="mr-1 badge badge-warning p-2 cst-inactive">Inactive</p>
      );
    }
    return (
      <Page title="View Participant">
        <ul className="cst-breadcrumb">
          <li>
            <Link to={"/dashboard"}>Home</Link>
          </li>
          <li>
            <Link to={"/allmentors"}>All Participants</Link>
          </li>
          <li>View Participant</li>
        </ul>
        <ReactTitle title="View Participant" />
        <Row className="view-monter">
          <Col xl={12} lg={12} md={12} className="profile-info profile-status">
            <Card className="p-0 mb-4">
              <CardHeader>
                <Label for="examplePassword" sm={12} className="px-0">
                  <strong>
                    <MdInfoOutline fontSize="24" className="mr-2" />
                    Participant Information
                  </strong>
                </Label>
                <ul>
                  {this.state.approval == false ? (
                    <li style={{ float: "right" }}>
                      <label htmlFor="exampleEmail" className="app-text">
                        Approve Participant
                        <Switch
                          onChange={this.handleChange}
                          checked={this.state.approval}
                          onColor="#45b649"
                          offColor="#ffd700"
                          // width	= {120}
                        />
                      </label>
                    </li>
                  ) : (
                    <li style={{ float: "right" }}>
                      {" "}
                      <span className="mr-2 badge badge-success  p-2">
                        Approved
                      </span>
                    </li>
                  )}
                </ul>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col md={2}>
                    {/* <CardImg className="card-img-left" src={image} style={{ width: '100%', height: 'auto' }} /> */}
                    <figure className="view-profile-img">
                      <img src={image} />
                    </figure>
                  </Col>
                  <Col md={5}>
                    <div className="row form-group mb-0">
                      <label
                        htmlFor="exampleEmail"
                        className="col-4 col-form-label"
                      >
                        Name
                      </label>
                      <label className="col-auto col-form-label">
                        {this.state.full_name ? this.state.full_name : "N/A"}{" "}
                      </label>
                    </div>

                    {/* <div className="row form-group mb-0">
                            <label htmlFor="exampleEmail" className="col-4 col-form-label">Middle Name</label>
                            <label className="col-auto col-form-label">{this.state.middlename ? this.state.middlename : 'N/A'} </label>
                            </div> */}

                    {/* <div className="row form-group mb-0">
                            <label htmlFor="exampleEmail" className="col-4 col-form-label">Last Name</label>
                            <label className="col-auto col-form-label">{this.state.lastname ? this.state.lastname : 'N/A'} </label>
                            </div> */}

                    <div className="row form-group mb-0">
                      <label
                        htmlFor="exampleEmail"
                        className="col-4 col-form-label"
                      >
                        {" "}
                        Gender
                      </label>
                      <label className="col-auto col-form-label">
                        {this.state.gender ? this.state.gender : "N/A"}{" "}
                      </label>
                    </div>

                    {/* <div className="row form-group mb-0">
                            <label htmlFor="exampleEmail" className="col-4 col-form-label"> Address 1</label>
                            <label className="col-7 col-form-label flex-column">
                                <p className="m-0 d-block">{this.state.address1 ? this.state.address1 : 'N/A'},</p>
                                
                            </label>
                            </div> */}
                    <div className="row form-group mb-0">
                      <label
                        htmlFor="exampleEmail"
                        className="col-4 col-form-label"
                      >
                        {" "}
                        Address{" "}
                      </label>
                      <label className="col-7 col-form-label flex-column">
                        <p className="m-0 d-block">
                          {this.state.address1 ? this.state.address1 : "N/A"},
                        </p>
                        <p className="m-0 d-block">
                          {this.state.address2 ? this.state.address2 : "N/A"},
                        </p>
                        <p className="m-0 d-block">
                          {this.state.city ? this.state.city : "N/A"},
                        </p>
                        <p className="m-0 d-block">
                          {this.state.state ? this.state.state : "N/A"}{" "}
                          {this.state.zipcode ? this.state.zipcode : "N/A"}
                        </p>
                      </label>
                    </div>

                    {/* <div className="row form-group mb-0">
                            <label htmlFor="exampleEmail" className="col-4 col-form-label"> Home Phone</label>
                            <label className="col-auto col-form-label">{this.state.homephone ? this.state.homephone : 'N/A'} </label>
                            </div> */}

                    <div className="row form-group mb-0">
                      <label
                        htmlFor="exampleEmail"
                        className="col-4 col-form-label"
                      >
                        {" "}
                        Phone
                      </label>
                      <label className="col-auto col-form-label">
                        {this.state.mobilephone
                          ? this.state.mobilephone
                          : "N/A"}{" "}
                      </label>
                    </div>
                  </Col>

                  <Col md={5}>
                    <div className="row form-group mb-0">
                      <label
                        htmlFor="exampleEmail"
                        className="col-4 col-form-label"
                      >
                        {" "}
                        Program
                      </label>
                      <label className="col-auto col-form-label">
                        <strong>
                          {this.state.program ? this.state.program : "N/A"}
                        </strong>{" "}
                      </label>
                    </div>

                    <div className="row form-group mb-0">
                      <label
                        htmlFor="exampleEmail"
                        className="col-4 col-form-label"
                      >
                        {" "}
                        Are you student?
                      </label>
                      <label className="col-form-label col-7">
                        {this.state.are_you_student
                          ? this.state.are_you_student
                          : "N/A"}{" "}
                      </label>
                    </div>
                    {this.state.are_you_student == "Yes" ? (
                      <div className="row form-group mb-0">
                        <label
                          htmlFor="exampleEmail"
                          className="col-4 col-form-label"
                        >
                          Where are you currently enrolled?
                        </label>
                        <label className="col-form-label col-7">
                          {this.state.currently_enrolled
                            ? this.state.currently_enrolled
                            : "N/A"}{" "}
                        </label>
                      </div>
                    ) : (
                      ""
                    )}

                    <div className="row form-group mb-0">
                      <label
                        htmlFor="exampleEmail"
                        className="col-4 col-form-label"
                      >
                        Are you currently employed?
                      </label>
                      <label className="col-form-label col-7">
                        {this.state.currently_employed
                          ? this.state.currently_employed
                          : "N/A"}{" "}
                      </label>
                    </div>
                    {this.state.currently_employed == "Yes" ? (
                      <div className="row form-group mb-0">
                        <label
                          htmlFor="exampleEmail"
                          className="col-4 col-form-label"
                        >
                          What is the name of the employer?
                        </label>
                        <label className="col-form-label col-7">
                          {this.state.employer_name
                            ? this.state.employer_name
                            : "N/A"}{" "}
                        </label>
                      </div>
                    ) : (
                      ""
                    )}
                    {/* 
                            <div className="row form-group mb-0">
                            <label htmlFor="exampleEmail" className="col-4 col-form-label"> Work Phone</label>
                            <label className="col-auto col-form-label">{this.state.workphone ? this.state.workphone : 'N/A'} </label>
                            </div> */}

                    {/* <div className="row form-group mb-0">
                            <label htmlFor="exampleEmail" className="col-4 col-form-label"> Occupation</label>
                            <label className="col-auto col-form-label">{this.state.occupation ? this.state.occupation : 'N/A'} </label>
                            </div> */}

                    <div className="row form-group mb-0">
                      <label
                        htmlFor="exampleEmail"
                        className="col-4 col-form-label"
                      >
                        {" "}
                        E-mail
                      </label>
                      <label className="col-auto col-form-label">
                        {this.state.emailaddress
                          ? this.state.emailaddress
                          : "N/A"}{" "}
                      </label>
                    </div>

                    <div className="row form-group ">
                      <label
                        htmlFor="exampleEmail"
                        className="col-4 col-form-label"
                      >
                        Status{" "}
                      </label>
                      {this.props.auth.user.user_type != "admin" ? (
                        <label className="col-auto col-form-label">
                          <Switch
                            onChange={this.handleStatus}
                            checked={this.state.status}
                            uncheckedIcon={
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  height: "100%",
                                  fontSize: 15,
                                  width: "150px",
                                  color: "#000",
                                  fontWeight: "bold",
                                  paddingRight: 2,
                                }}
                              >
                                Inactive
                              </div>
                            }
                            checkedIcon={
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  height: "100%",
                                  fontSize: 15,
                                  width: "180px",
                                  fontWeight: "bold",
                                  color: "#000",
                                  paddingRight: 2,
                                }}
                              >
                                Active
                              </div>
                            }
                            onColor="#45b649"
                            offColor="#ffd700"
                            className="react-switch"
                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                            height={20}
                            width={48}
                            handleDiameter={30}
                          />
                        </label>
                      ) : (
                        <p className="col-6">{parent_status}</p>
                      )}
                    </div>
                    {this.state.admin_res != undefined ? (
                      <div className="row form-group">
                        <label
                          htmlFor="exampleEmail"
                          className="col-4 col-form-label"
                        >
                          Admin Response
                        </label>
                        {this.state.admin_res == false ? (
                          <Switch
                            onChange={this.handleResponse}
                            checked={this.state.admin_res}
                            onColor="#45b649"
                            offColor="#ffd700"
                          />
                        ) : (
                          <span className="mr-2 badge badge-success p-2">
                            Responded
                          </span>
                        )}
                      </div>
                    ) : (
                      ""
                    )}
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card className="pt-0 therma-ques">
              <CardBody className="p-0">
                <Thermometerdt data={this.props.match.params.id} />
              </CardBody>
            </Card>
          </Col>
        </Row>

        <ViewMentorTodo data={this.props.match.params.id} />

        <Row className="mt-4 ">
          <Col xl={6} lg={12} md={12} className="profile-info">
            <Card className="p-0 mb-4">
              <CardHeader>
                <Label for="examplePassword" sm={12} className="px-0">
                  <strong>
                    <MdQuestionAnswer fontSize="24" className="mr-2" />
                    Participant Questionnaire
                  </strong>
                </Label>
              </CardHeader>
              <CardBody>
                <Row className="qa-list">
                  <Col md={12}>
                    {!this.state.isNewUser&&<div className="row form-group mb-4">
                      <h5>1. Indicate your grade preference:</h5>
                      <p>
                        {" "}
                        {this.state.grade_preference
                          ? this.state.grade_preference
                          : "N/A"}
                      </p>
                    </div>}

                    {!this.state.isNewUser&&<div className="row form-group mb-4">
                      <h5>
                        2. What do you feel are the strengths (bilingual, math
                        skills, previous relevant volunteer experience, etc.)
                        you can bring to this program?
                      </h5>
                      <p>
                        {" "}
                        {this.state.strengths ? this.state.strengths : "N/A"}
                      </p>
                    </div>}

                    {!this.state.isNewUser&&<div className="row form-group mb-4">
                      <h5>
                        3. Write a brief statement on why you have chosen to
                        participate in the participant program.
                      </h5>
                      <p>
                        {this.state.statement_behind_mentor
                          ? this.state.statement_behind_mentor
                          : "N/A"}
                      </p>
                    </div>}

                    {!this.state.isNewUser&&<div className="row form-group mb-4">
                      <h5>
                        4. I understand that the Participant program involves
                        spending minimum one hour for every week for the
                        academic year at a school with an assigned student
                      </h5>
                      <p>
                        {this.state.intial_statement_ques1
                          ? this.state.intial_statement_ques1
                          : "N/A"}{" "}
                      </p>
                    </div>}

                    {!this.state.isNewUser&&<div className="row form-group mb-4">
                      <h5>
                        5. I understand that i will be required to complete the
                        participant program orientation and least two training
                        sessions during the year
                      </h5>
                      <p>
                        {this.state.intial_statement_ques2
                          ? this.state.intial_statement_ques2
                          : "N/A"}{" "}
                      </p>
                    </div>}

                    {!this.state.isNewUser&&<div className="row form-group mb-4">
                      <h5>
                        6. Within the past 10 years, have you been convicted of
                        any felony or misdemeanor classified as an offense
                        against a person or family, or an offense of public
                        indecency or a violation involving a state/federally
                        controlled substance?
                      </h5>
                      <p>
                        {" "}
                        {this.state.convicted_misdemeanor
                          ? this.state.convicted_misdemeanor
                          : "N/A"}
                      </p>
                      {this.state.explaination1&&<p>{this.state.explaination1}</p>}
                    </div>}

                    {!this.state.isNewUser&&<div className="row form-group mb-4">
                      <h5>
                        7. Are you under current indictment or has a
                        district/county attorney accepted an official complaint
                        for any of the offenses in question #5?
                      </h5>
                      <p>
                        {" "}
                        {this.state.current_indictment
                          ? this.state.current_indictment
                          : "N/A"}
                      </p>
                      {this.state.explaination2&&<p>{this.state.explaination2}</p>}
                    </div>}

                    <div className="row form-group mb-4">
                      <h5>{this.state.isNewUser?"1. Educational Background (mark one):":" Educational Background (mark one):"}</h5>
                      <p>
                        {" "}
                        {this.state.educational_background
                          ? this.state.educational_background
                          : "N/A"}
                      </p>
                    </div>

                    {!this.state.isNewUser&&<div className="row form-group mb-4">
                      <h5>9. Why do you want to become a Participant?</h5>
                      <p>
                        {" "}
                        {this.state.reason_behind_mentor
                          ? this.state.reason_behind_mentor
                          : "N/A"}
                      </p>
                    </div>}

                    {!this.state.isNewUser&&<div className="row form-group mb-4">
                      <h5>
                        10. What days of the week are you available to
                        volunteer? (check all that apply):
                      </h5>
                      {/* <p> {this.state.available_days?this.state.available_days:"N/A"}</p> */}
                      <p>
                        {this.state.available_days&&this.state.available_days.length?this.state.available_days.map((res, i, arr) => {
                          return (
                            <span>
                              {" "}
                              {res} {i != arr.length - 1 ? "," : ""}
                            </span>
                          );
                        }):"N/A"}
                      </p>
                    </div>}

                    {!this.state.isNewUser&&<div className="row form-group mb-4">
                      <h5>
                        11. What is the best time for you to volunteer? (check
                        all that apply):
                      </h5>
                      {/* <p> {this.state.best_time_for_voluntee?this.state.best_time_for_voluntee:"N/A"}</p> */}
                      <p>
                        {this.state.best_time_for_voluntee&&this.state.best_time_for_voluntee.length?this.state.best_time_for_voluntee.map(
                          (res, i, arr) => {
                            return (
                              <span>
                                {" "}
                                {res} {i != arr.length - 1 ? "," : ""}
                              </span>
                            );
                          }
                        ):"N/A"}
                      </p>
                    </div>}

                    {!this.state.isNewUser&&<div className="row form-group mb-4 mentor-view_enroll">
                      <h5>
                        12. Please list four references (please include at least
                        one family member, one personal friend and one work
                        reference):
                      </h5>
                      {/* <table>
                                              <thead>
                                                <tr>
                                                  <td>Name</td>
                                                  <td>Phone</td>
                                                  <td>Relation</td>
                                                  <td>Address</td>
                                                  <td>State</td>
                                                  <td>Zip Code</td>
                                                </tr>
                                              </thead>
                                            </table> */}
                      {/* <p> {this.state.referal_addresses?this.state.referal_addresses:"N/A"}</p> */}
                      {/* {console.log(
                        "this.state.referal_addresses",
                        this.state.referal_addresses
                      )} */}
                      {this.state.referal_addresses&&this.state.referal_addresses.length?this.state.referal_addresses.map((result, i) => {
                        return (
                          <span className="mentor-view_scroll">
                            <p className="mentor-view_name w-100 font-weight-bold pt-2 pb-1">
                              {" "}
                              {result.name}
                            </p>

                            <p className="mentor-view_name w-100 py-1">
                              {" "}
                              {result.phone}
                            </p>

                            <p className="mentor-view_name w-100 py-1">
                              {" "}
                              {result.relation}
                            </p>

                            <p className="mentor-view_name w-100 py-1">
                              {" "}
                              {result.address1}
                            </p>
                            <p className="mentor-view_name w-100 py-1">
                              {" "}
                              {result.address2}
                            </p>
                            <p className="mentor-view_name w-100 py-1">
                              {" "}
                              {result.city ? result.city : "N/A"}
                            </p>
                            <p className="mentor-view_name w-100 py-1">
                              {" "}
                              {result.selectedState}
                              {result.state} {result.zipcode}
                            </p>
                          </span>
                        );
                      }):"N/A"}
                    </div>}
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>

          <Col xl={6} lg={12} md={12} className="profile-info">
            <Card className="p-0 mb-4">
              <CardHeader>
                <Label for="examplePassword" sm={12} className="px-0">
                  <strong>
                    <MdInfoOutline fontSize="24" className="mr-2" />
                    Optional Information
                  </strong>
                </Label>
              </CardHeader>
              <CardBody>
                <Row className="qa-list">
                  <Col md={12}>
                    {/* <div className="row form-group mb-4">
                                    <h5>1. Social Security number (needed for criminal record checks):</h5>
                                    <p> {this.state.social_security_number?this.state.social_security_number:"N/A"}</p>
                                  </div>

                                  <div className="row form-group mb-4">
                                    <h5>2.Birth date (needed for record checks)</h5>
                                    <p> {this.state.date_of_birth?this.state.date_of_birth:"N/A"}  </p>
                                  </div> */}

                    {!this.state.isNewUser&&<div className="row form-group mb-4">
                      <h5>
                        3.Do you prefer working with a particular grade level
                        (approximate ages are in parentheses)?
                      </h5>
                      <p>
                        {" "}
                        {this.state.prefer_particular_grade_level
                          ? this.state.prefer_particular_grade_level
                          : "N/A"}{" "}
                      </p>
                    </div>}

                    {!this.state.isNewUser&&<div className="row form-group mb-4">
                      <h5>4.Do you prefer working with </h5>
                      <p>
                        {" "}
                        {this.state.prefer_particular_gender
                          ? this.state.prefer_particular_gender
                          : "N/A"}{" "}
                      </p>
                    </div>}

                    {!this.state.isNewUser&&<div className="row form-group mb-4">
                      <h5>
                        5.Do you prefer working with a quiet, reserved child?
                      </h5>
                      <p>
                        {" "}
                        {this.state.prefer_quiet
                          ? this.state.prefer_quiet
                          : "N/A"}{" "}
                      </p>
                    </div>}

                    {!this.state.isNewUser&&<div className="row form-group mb-4">
                      <h5>6.Do you prefer working with an outgoing child?</h5>
                      <p>
                        {" "}
                        {this.state.prefer_outgoing_child
                          ? this.state.prefer_outgoing_child
                          : "N/A"}{" "}
                      </p>
                    </div>}

                    {!this.state.isNewUser&&<div className="row form-group mb-4">
                      <h5>
                        7.Do you prefer working with a student from a specific
                        racial/ethnic group?
                      </h5>
                      <p>
                        {" "}
                        {this.state.prefer_specific_racial
                          ? this.state.prefer_specific_racial
                          : "N/A"}{" "}
                      </p>
                      {this.state.prefer_specific_racial_text&&<p>{this.state.prefer_specific_racial_text} </p>}
                    </div>}

                    <div className="row form-group mb-4">
                      <h5>{this.state.isNewUser?"What language(s) do you speak?":"8.Do you speak a foreign language"}</h5>
                      <p>
                        {" "}
                        {this.state.foreign_language
                          ? this.state.foreign_language
                          : "N/A"}{" "}
                      </p>
                      {this.state.foreign_language_other&&<p>{this.state.foreign_language_other} </p>}
                    </div>

                    {!this.state.isNewUser&&<div className="row form-group mb-4">
                      <h5>
                        9.Please list any hobbies or interests you may have:
                      </h5>
                      <p> {this.state.hobbies ? this.state.hobbies : "N/A"} </p>
                    </div>}

                    {!this.state.isNewUser&&<div className="row form-group mb-4">
                      <h5>10.What would you like to do with a mentee?</h5>
                      <p>
                        {" "}
                        {this.state.like_to_be_mentee
                          ? this.state.like_to_be_mentee
                          : "N/A"}{" "}
                      </p>
                    </div>}

                    {!this.state.isNewUser&&<div className="row form-group mb-4">
                      <h5>
                        11.What clubs or groups, if any, do you belong to?
                      </h5>
                      <p>
                        {" "}
                        {this.state.clubs_or_groups
                          ? this.state.clubs_or_groups
                          : "N/A"}{" "}
                      </p>
                    </div>}

                    {!this.state.isNewUser&&<div className="row form-group mb-4">
                      <h5>12.My favorite subject in school was</h5>
                      <p>
                        {" "}
                        {this.state.favorite_subject
                          ? this.state.favorite_subject
                          : "N/A"}{" "}
                      </p>
                    </div>}

                    {!this.state.isNewUser&&<div className="row form-group mb-4">
                      <h5>13.My least favorite subject in school was</h5>
                      <p>
                        {" "}
                        {this.state.least_favorite_subject
                          ? this.state.least_favorite_subject
                          : "N/A"}{" "}
                      </p>
                    </div>}

                    {!this.state.isNewUser&&<div className="row form-group mb-4">
                      <h5>14.Please select activities you enjoy the most</h5>
                      {/* <p> {this.state.enjoyed_activities?this.state.enjoyed_activities:"N/A"}  </p> */}
                      <p>
                        {this.state.enjoyed_activities&&this.state.enjoyed_activities.length?this.state.enjoyed_activities.map((res, i, arr) => {
                          return (
                            <span>
                              {" "}
                              {res} {i != arr.length - 1 ? "," : ""}
                            </span>
                          );
                        }):"N/A"}
                      </p>
                    </div>}

                    {!this.state.isNewUser&&<div className="row form-group mb-4">
                      <h5>15.What qualities would you like in a mentee?</h5>
                      <p>
                        {" "}
                        {this.state.qualities_like_in_mentee
                          ? this.state.qualities_like_in_mentee
                          : "N/A"}{" "}
                      </p>
                    </div>}

                    {!this.state.isNewUser&&<div className="row form-group mb-4">
                      <h5>
                        16.What individual has served as a role model for you?
                        Why?
                      </h5>
                      <p>
                        {this.state.role_model ? this.state.role_model : "N/A"}{" "}
                      </p>
                    </div>}

                    {!this.state.isNewUser&&<div className="row form-group mb-4">
                      <h5>
                        17.If you could recommend one book for your mentee to
                        read, what would it be??
                      </h5>
                      <p>
                        {" "}
                        {this.state.grade_preference
                          ? this.state.grade_preference
                          : "N/A"}{" "}
                      </p>
                    </div>}

                    <div className="row form-group mb-4">
                      <h5>{!this.state.isNewUser?"18.Signature":"Signature"}</h5>
                      <figure className="view-profile-img">
                        <img src={this.state.signature} />
                      </figure>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Page>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
});
export default connect(mapStateToProps, {})(ViewMentor);
// export default ViewMentor;
